import React, { FC } from 'react';
import { ReactComponent as Hamburger } from '../../../assets/Common/Hamburger.svg';

export const HamburgerIcon: FC = () => <Hamburger />;
